(function () {
  function initTrack(root) {
    if (root.getAttribute('data-eps-bound') === 'true') return;

    var track = root.querySelector('[data-eps-track]');
    if (!track) return;

    var controls = root.querySelector('[data-eps-controls]');
    var prevBtns = Array.prototype.slice.call(root.querySelectorAll('.eps-stats-btn--prev'));
    var nextBtns = Array.prototype.slice.call(root.querySelectorAll('.eps-stats-btn--next'));
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    var currentIndex = 0;

    function getGap() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap);
      return isNaN(gap) ? 10 : gap;
    }

    function getItemWidth(index) {
      var item = items[index] || items[0];
      return item.getBoundingClientRect().width;
    }

    function getScrollPositionForIndex(index) {
      if (index <= 0) return 0;
      var gap = getGap();
      var position = 0;
      for (var i = 0; i < index; i++) {
        position += getItemWidth(i) + gap;
      }
      return position;
    }

    function getMaxScrollPosition() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function needsSlider() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function updateControlsVisibility() {
      if (!controls) return;
      controls.classList.toggle('is-active', needsSlider());
    }

    function updateButtonStates() {
      var maxScroll = getMaxScrollPosition();
      var isPrevDisabled = currentIndex <= 0;
      var isNextDisabled = currentIndex >= items.length - 1 || getScrollPositionForIndex(currentIndex) >= maxScroll - 1;
      prevBtns.forEach(function (btn) { btn.disabled = isPrevDisabled; });
      nextBtns.forEach(function (btn) { btn.disabled = isNextDisabled; });
    }

    function scrollToIndex(index) {
      if (index < 0) index = 0;
      if (index > items.length - 1) index = items.length - 1;
      currentIndex = index;
      var target = Math.min(getScrollPositionForIndex(index), getMaxScrollPosition());
      track.scrollTo({ left: target, behavior: 'smooth' });
      updateButtonStates();
    }

    function findCurrentIndexFromScroll() {
      var scrollLeft = track.scrollLeft;
      var gap = getGap();
      var accumulated = 0;
      for (var i = 0; i < items.length; i++) {
        var width = getItemWidth(i);
        if (scrollLeft < accumulated + width / 2) return i;
        accumulated += width + gap;
      }
      return items.length - 1;
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToIndex(currentIndex - 1);
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToIndex(currentIndex + 1);
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        currentIndex = findCurrentIndexFromScroll();
        updateButtonStates();
      }, 100);
    });

    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragMoved = false;
      dragStartX = e.pageX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var delta = e.pageX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      track.scrollLeft = dragStartScrollLeft - delta;
      e.preventDefault();
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      currentIndex = findCurrentIndexFromScroll();
      updateButtonStates();
    });

    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        updateControlsVisibility();
        updateButtonStates();
      }, 150);
    });

    updateControlsVisibility();
    updateButtonStates();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        updateControlsVisibility();
        updateButtonStates();
      });
      ro.observe(track);

      root.addEventListener('shopify:section:unload', function () {
        ro.disconnect();
      });
    }

    root.setAttribute('data-eps-bound', 'true');
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-proof-showcase]');
    Array.prototype.forEach.call(roots, function (root) {
      initTrack(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event && event.target ? event.target.querySelector('[data-proof-showcase]') : null;
    if (root) {
      initTrack(root);
    } else {
      initAll();
    }
  });
})();
